const STORAGE_KEY = "labor.tab_id";

/** When sessionStorage is unavailable, lockdown cannot match this tab to a session. */
export const LABOR_TAB_ID_NO_STORAGE = "no-storage";

let memoized: string | null = null;

/**
 * Stable per-browser-tab identifier for labor lockdown. Stored in sessionStorage so a hard
 * reload of a working URL keeps the same tab identity.
 */
export function getLaborTabId(): string {
  if (typeof window === "undefined") {
    return LABOR_TAB_ID_NO_STORAGE;
  }
  if (memoized !== null) {
    return memoized;
  }
  try {
    const existing = window.sessionStorage.getItem(STORAGE_KEY);
    if (existing != null && existing.trim() !== "") {
      memoized = existing;
      return existing;
    }
    const next = crypto.randomUUID();
    window.sessionStorage.setItem(STORAGE_KEY, next);
    memoized = next;
    return next;
  } catch {
    memoized = LABOR_TAB_ID_NO_STORAGE;
    return LABOR_TAB_ID_NO_STORAGE;
  }
}

/** Test-only: clears the in-memory memo (does not clear sessionStorage). */
export function resetLaborTabIdMemoForTests(): void {
  memoized = null;
}
